import { DettaglioMovimento } from './dettaglio-movimento';

export class MovimentoArticolo {
  id: number;
  idArticolo: number;
  idDipendente: number;
  data: Date;
  qta: number;
  cambio: boolean;
  dettagli: string;
  firmato: boolean;
  allegato: string;
  allegatoByte: string;
  progr: number;

  idReparto: number;
  idMansione: number;
  idResponsabile: number;
}

export class MovimentoArticoloModel {
  gestioneGiornaliera?: TipoGestioneGiornaliera;
  idDipendente: number;
  data: Date;
  dettagli: string;
  firmato: boolean;
  allegato: string;
  allegatoByte: string;
  progr: number;
  listDettaglio: DettaglioMovimento[] = [];
  nominativoDipendente: string;
  inviaMail: boolean;
}

export class NewMovimentoArticoloResponse {
  newMovimento: MovimentoArticoloModel;
  result: boolean;
  errori: string[];
}

export enum TipoGestioneGiornaliera {
  consegnaNonGiornaliera = 0, //Non giornaliera
  consegnaGiornaliera = 1,
  restituzioneGiornaliera = 2,
}
